import { toCategoryListPage } from '@/feature/product-list/services/productList.routing'
import type { ButtonVariant } from '@/ui/buttons/button-styles/ButtonStyles'
import type { TypeIcons } from '@/ui/icons/icon/Icon'
import { z } from 'zod'

export const metadataSchema = z.object({
  title: z.string().min(1).optional(),
  description: z.string().min(1).optional(),
  keywords: z.string().min(1).optional(),
})

export const linkSchema = z.object({
  url: z.string(),
  label: z.string().min(1),
  iconLeft: z.custom<TypeIcons>().optional(),
  iconRight: z.custom<TypeIcons>().optional(),
  variant: z.custom<ButtonVariant>().optional(),
})

export type LinkType = z.infer<typeof linkSchema>

export const categoryListLinkSchema = linkSchema.transform((link) => ({
  ...link,
  url: toCategoryListPage(link.url),
}))

export const storeLocatorLinkSchema = linkSchema.extend({
  url: z.string().optional(),
})
